<template>
  <div class="project-list">
    <div class="loader with-padding" v-if="status === 'Fetching'">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <h1 v-else-if="errMessage" class="error-fetching">
      {{ errMessage }}
    </h1>
    <v-list subheader v-else class="project-list-items">
      <v-subheader inset>Title</v-subheader>
      <v-divider></v-divider>
      <v-list-tile avatar v-for="project in openProjects" :key="project._id" @click="selectProject(project._id)" class="hover-darken project">
        <v-list-tile-avatar tile>
          <img src="http://via.placeholder.com/50x50" alt="Project Image">
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="project.name"></v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-list-tile-title v-html="project.created"></v-list-tile-title>
        </v-list-tile-action>
        <v-list-tile-action>
          <v-icon>more_vert</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ProjectList',
  data() {
    return {
      header: ['', 'Title', 'Owner', 'Last Modified'],
    };
  },
  computed: {
    ...mapGetters({
      openProjects: 'projects/openProjects',
    }),
    ...mapState({
      status: state => state.projects.status,
      errMessage: state => state.projects.errMessage,
    }),
  },
  methods: {
    async selectProject(projectId) {
      await this.$store.dispatch('projects/select', projectId);
      this.$router.push({ path: `/project/${projectId}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.project-list {
  width: 100%;
  .project {
    padding-left: 35px;
  }
}
.project-list-items {
  margin-top: 50px;
}
h1 {
  font-family: 'Karla', sans-serif;
  margin-left: 86px;
  font-size: 34px;
	font-weight: bold;
	line-height: 1.12;
}
p {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectList.vue